var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBolt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 14h-7.212l2.663-8.113A1.506 1.506 0 0022.5 4h-9c-.75 0-1.388.556-1.488 1.3l-2 15c-.119.9.581 1.7 1.488 1.7h7.418l-2.88 12.156a1.498 1.498 0 002.755 1.094l11-19c.582-.994-.137-2.25-1.293-2.25zm-9.73 17.306l2.093-8.85.581-2.462H12.07L13.94 6h7.868l-2.419 7.375L18.526 16h9.106l-8.863 15.306z"
  })));
}
export default SvgBolt;